export default class PlayerError extends Error {
  constructor(message: string, payload?: Record<string, any>) {
    super(message);
    this.name = 'PlayerError';
    this.stack = JSON.stringify(payload ?? {}, null, '\t');
  }
}
